import {
  getDcrList,
  getDcrListById,
  addDcrList,
  deleteDcrListAPI
} from '../../../services/DCR/DCRService';

export const fetchDcrList = async (clientFilterDetails) => {
  try {
    const response = await getDcrList(clientFilterDetails);

    if (response && response.success) {
      return response.returnResult || [];
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching clients list',
        variant: 'error'
      });
      console.log('Error fetching clients list:', response?.message);
      return [];
    }
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching clients list',
      variant: 'error'
    });
    console.log('Error fetching clients list:', err);
    return [];
  }
};

export const fetchDcrListById = async (clientGUID) => {
  try {
    const response = await getDcrListById(clientGUID);

    if (response && response.success) {
      return response;
    } else {
      window.showSnackbar({
        message: response?.message || 'An error occurred while fetching clients details',
        variant: 'error'
      });
      console.log('Error fetching clients details:', response?.message);
      return response;
    }
    return null;
  } catch (err) {
    window.showSnackbar({
      message: err.message || 'An error occurred while fetching clients details',
      variant: 'error'
    });
    console.log('Error fetching clients details:', err);
    return null;
  }
};

export const saveDcrList = async (payload, customSuccessMsg, customErrorMsg) => {
  try {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    const apiPayload = {
      ...payload,
      ...{
        createdGUID: user.userGUID,
        modifiedGUID: user.userGUID,
        createdDate: new Date(),
        modifiedDate: new Date()
      }
    };
    const response = await addDcrList(apiPayload);
    if (!response || !response.success) {
      console.log('response?.message', response?.message || 'Failed to save client');
      window.showSnackbar({
        message: customErrorMsg || `Failed to save client`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Client saved successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save client');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save client:', err);
    return { success: false, message: errorMessage };
  }
};

export const deleteDcrList = async (clientGUID, customSuccessMsg, customErrorMsg) => {
  try {
    const response = await deleteDcrListAPI(clientGUID);
    if (!response || !response.success) {
      window.showSnackbar({
        message: customErrorMsg || `Failed to save client`,
        variant: 'error'
      });
    } else {
      window.showSnackbar({
        message: customSuccessMsg || `Client Deleted successfully`,
        variant: 'success'
      });
    }
    return response;
  } catch (err) {
    const errorMessage = err?.message || (typeof err === 'string' ? err : 'Failed to save client');
    window.showSnackbar({
      message: errorMessage,
      variant: 'error'
    });
    console.log('Failed to save client:', err);
    return { success: false, message: errorMessage };
  }
};
